import * as STD from '@emersya/mpa-std';
import * as CM  from '@emersya/mpa-components-manager';

import { MenuPanel, Text, InputButton }     from '@emersya/mpa-components';

export interface IMPAEngineConfiguratorMenuComponentConfiguration extends CM.DOMComponent.IConfiguration {
	// To not duplicate many property of the app configuration, and because this component is unique, retrieve conf directly from app and lets this interface be empty.
};

export class MPAEngineConfiguratorMenuComponent extends CM.DOMComponent<
	HTMLDivElement,
	MPAEngineConfiguratorMenuComponent,
	IMPAEngineConfiguratorMenuComponentConfiguration
> {
	static override initialize() {
		super.initialize();
	};

	component_DOM: HTMLDivElement;

	private async addUIModule(module: EngineModule.UIEngineModule<any>) {
		const isStepMenu = app.component_configuration.useStepConfiguratorMenu;
		const sectionsIcons = this.component_find('@:sectionsIcons');
		const panel = this.component_find('@:panel');

		// Section icons
		{
			const iconButton = <CM.DOMComponent<any, any, any>>await sectionsIcons.component_instantiateOuterChild(
				{
					type: 'input-button',
					id: module.id,
					tree: this.component_tree,
					slot: null,
					isSlot: false,
					configuration: {}
				}
			);

			if (isStepMenu) {
				// TODO idx is used for step menu buttons
				// It needs to starts at 1 so it should be idx + 1 but product-editor is hidden
				// If product-editor is not hidden it would appear as step 0
				await iconButton.component_instantiateOuterChild(
					{
						type: 'text',
						id: 'text-icon',
						tree: this.component_tree,
						slot: null,
						isSlot: false,
						configuration: {
						}
					}
				);

			} else {
				await iconButton.component_instantiateOuterChild(
					{
						type: 'image',
						id: 'icon',
						tree: this.component_tree,
						slot: null,
						isSlot: false,
						configuration: {
							'@translations': {
								'@name': module.translations['@name']
							},
							'@classList': ['imgConstrainedByTheContainer']
						}
					}
				);
			}
		}
		// Panel
		{
			const section = <CM.DOMComponent<any, any, any>>await panel.component_instantiateOuterChild(
				{
					type: 'section',
					id: module.id,
					tree: this.component_tree,
					slot: null,
					isSlot: false,
					configuration: {}
				}
			);
			const header = <CM.DOMComponent<any, any, any>>await section.component_instantiateOuterChild(
				{
					type: isStepMenu ? 'block' : 'input-button',
					id: 'header',
					tree: this.component_tree,
					slot: null,
					isSlot: false,
					configuration: {}
				}
			);
			const headerTitles = <CM.DOMComponent<any, any, any>>await header.component_instantiateOuterChild(
				{
					type: 'block',
					id: '-',
					tree: this.component_tree,
					slot: null,
					isSlot: false,
					configuration: {}
				}
			);
			const headerTitlesSection = <CM.DOMComponent<any, any, any>>await headerTitles.component_instantiateOuterChild(
				{
					type: 'text',
					id: 'title',
					tree: this.component_tree,
					slot: null,
					isSlot: false,
					configuration: {}
				}
			);
			headerTitlesSection.component_DOM.classList.add('text-title-section');

			if (isStepMenu) {
				await header.component_instantiateOuterChild(
					{
						type: 'input-button',
						id: 'previous',
						tree: this.component_tree,
						slot: null,
						isSlot: false,
						configuration: {}
					}
				);

				await header.component_instantiateOuterChild(
					{
						type: 'input-button',
						id: 'next',
						tree: this.component_tree,
						slot: null,
						isSlot: false,
						configuration: {}
					}
				);
			} else {
				/**
				 * headerTitlesSelected = Not used anymore?
				 **/
				await headerTitles.component_instantiateOuterChild(
					{
						type: 'text',
						id: 'selected',
						tree: this.component_tree,
						slot: null,
						isSlot: false,
						configuration: {}
					}
				);
				await header.component_instantiateOuterChild(
					{
						type: 'input-button',
						id: 'open',
						tree: this.component_tree,
						slot: null,
						isSlot: false,
						configuration: {
							'@classList': ['icon'],
							'@stringData': 'Ù'
						}
					}
				);
				await header.component_instantiateOuterChild(
					{
						type: 'input-button',
						id: 'close',
						tree: this.component_tree,
						slot: null,
						isSlot: false,
						configuration: {
							'@classList': ['icon'],
							'@stringData': 'q'
						}
					}
				);
			}

			const content = <CM.DOMComponent<any, any, any>>await section.component_instantiateOuterChild(
				{
					type: module.getComponentType(),
					id: 'content',
					tree: this.component_tree,
					slot: null,
					isSlot: false,
					configuration: await module.generateComponentConfiguration.call(module)
				}
			);
			module.assignComponent(content);
			void content;
			void headerTitlesSection;
		}
		void panel;
	};

	private async addLogicalModule(module: EngineModule.LogicalEngineModule<any>) {
		if (!module.insertionPath) {
			return;
		}
		if (!module.generateComponentConfiguration) {
			this.component_throwUserError('Module without "generateComponentConfiguration" method!', {module});
		}
		const parent = app.component_find(module.insertionPath);
		module.assignComponent(await parent.component_instantiateOuterChild(
			{
				type: module.getComponentType(),
				id: module.id,
				tree: this.component_tree,
				slot: null,
				isSlot: false,
				configuration: await module.generateComponentConfiguration.call(module)
			}
		));
	};

	async refreshIndex(){
		let index = 0;
		let lastModule;
		for (const module of EngineModule.usedWithPageOrdered) {
			const header = this.component_find(`@:panel.${module.id}.header`);
			if(module.displayCondition){
				const displayCondition = await module.displayCondition.evaluate(this);
				if(displayCondition){
					const sectionsIcons = <Text.Component>this.component_find(`@:sectionsIcons.${module.id}.text-icon`);
					index += 1;
					sectionsIcons.component_DOM.textContent = index.toString();
					if(index === 1){
						const previous = <InputButton.Component>header.component_find('@.previous');
						previous.component_DOM.classList.add('hidden');
					};
					if(lastModule){
						const lastNext = <InputButton.Component>lastModule.component_find('@.next');
						lastNext.component_DOM.classList.remove('hidden');
					}
					lastModule = header;
					const next = <InputButton.Component>header.component_find('@.next');
					next.component_DOM.classList.add('hidden');
				}
			}else{
				const sectionsIcons = <Text.Component>this.component_find(`@:sectionsIcons.${module.id}.text-icon`);
				index += 1;
				sectionsIcons.component_DOM.textContent = index.toString();
				if(index === 1){
					const previous = <InputButton.Component>header.component_find('@.previous');
					previous.component_DOM.classList.add('hidden');
				}
				if(lastModule){
					const lastNext = <InputButton.Component>lastModule.component_find('@.next');
					lastNext.component_DOM.classList.remove('hidden');
				}
				lastModule = header;
				const next = <InputButton.Component>header.component_find('@.next');
				next.component_DOM.classList.add('hidden');
			}
		}
	}

	override async component_initialize() {
		for (const module of EngineModule.usedWithPageOrdered) {
			await this.addUIModule(module);
		}
		for (const module of EngineModule.used.filter(x => x.type === 'logical')) {
			await this.addLogicalModule(<EngineModule.LogicalEngineModule<any>>module);
		}
		await super.component_initialize();
	};

	private updateAfterSectionChange() {
		const panel = <MenuPanel.Component>this.component_find('@:panel');
		this.component_DOM.dataset.currentSection = panel.currentSections[0]?.id || '';
	};

	constructor(
		descriptor: ConstructorParameters<typeof CM.Component>[0],
		configuration: IMPAEngineConfiguratorMenuComponentConfiguration
	) {
		super(descriptor, configuration);
		this.component_DOM = <HTMLDivElement>STD.DOM.factory({
			tag: 'div'
		});
		if (app.component_configuration.useStepConfiguratorMenu) {
			this.component_DOM.classList.add('stepMenu');
		}
		void this.updateAfterSectionChange;
	};
};
export namespace NS {
	export const Component = MPAEngineConfiguratorMenuComponent;
	export type Component = MPAEngineConfiguratorMenuComponent;
	export type Configuration = IMPAEngineConfiguratorMenuComponentConfiguration;
}
;
import manifestXMLSource from './MPAEngineConfiguratorMenu.xml';
import './MPAEngineConfiguratorMenu.scss';
import EngineModule      from '../../EngineModule';

CM.Manager.declare({
	id: 'mpaengine-configuratorMenu',
	type: MPAEngineConfiguratorMenuComponent,
	manifest: manifestXMLSource
});
